import { render, staticRenderFns } from "./CrmTicketIndex.vue?vue&type=template&id=d6db13b8&scoped=true"
import script from "./CrmTicketIndex.vue?vue&type=script&lang=js"
export * from "./CrmTicketIndex.vue?vue&type=script&lang=js"
import style0 from "./CrmTicketIndex.vue?vue&type=style&index=0&id=d6db13b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6db13b8",
  null
  
)

export default component.exports